import styled from '@emotion/styled';
import { CountryCode, isValidNumber } from 'libphonenumber-js';
import {
  parseIncompletePhoneNumber,
  parsePhoneNumberWithError,
} from 'libphonenumber-js/max';
import { classes, MuiTelInput, MuiTelInputProps } from 'mui-tel-input';
import { memo, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { useTranslation } from '../../../contexts/TranslationContext';
import { accountCompanyInfoAtom } from '../../../models/atoms/account_atoms';

type PhoneNumberInputProps = MuiTelInputProps & {
  setPhoneValidationError: (arg0: string) => void;
  onValid: (arg0: string) => void;
  name?: string | undefined;
};

const StyledPhoneNumberInput = styled(MuiTelInput)`
  .MuiInputBase-root {
    border-radius: 5px;
    padding: 0rem 0rem;
  }
  .${classes.flagContainer} {
    padding: 0rem 0.5rem;
  }
  .${classes.flagButton} {
    padding: 0rem 0.5rem;
  }
  .MuiInputBase-input {
    padding: 0.5rem;
    font-family: 'Ubuntu', sans-serif;
  }
`;

export const PhoneNumberInput = memo(function PhoneNumberInput(
  props: PhoneNumberInputProps,
) {
  const {
    sx,
    name,
    value,
    onChange,
    onValid,
    setPhoneValidationError,
    ...rest
  } = props;
  const companyInfo = useRecoilValue(accountCompanyInfoAtom);
  const [phoneNumber, setPhoneNumber] = useState(value);
  const { t } = useTranslation();
  console.log('rerender phone number');

  return (
    <StyledPhoneNumberInput
      sx={{ width: '100%', ...sx }}
      name={name}
      value={phoneNumber}
      size="small"
      defaultCountry={(companyInfo?.country_code as CountryCode) ?? 'US'}
      onChange={value => {
        setPhoneValidationError('');
        const phone_number_string = parseIncompletePhoneNumber(value);
        setPhoneNumber(value.toString());
        console.log(phone_number_string);
        try {
          const phone_number = parsePhoneNumberWithError(phone_number_string);
          if (!isValidNumber(phone_number_string, phone_number.country)) {
            props.setPhoneValidationError(
              t('Please provide a valid phone number!'),
            );
            return;
          }
          onValid(phone_number_string);
          //if (changeUser == null) { return; }
          //props.setChangeUser({...changeUser, phone_number: phone_number_string, change_email_phone: true});
        } catch (_) {
          //console.log(e)
          setPhoneValidationError(t('Please provide a valid phone number!'));
        }
      }}
      {...rest}
    />
  );
});

const ModalStyledPhoneNumberInput = styled(MuiTelInput)`
  .MuiInputBase-root {
    border-radius: 5px;
  }
  .${classes.flagContainer} {
    padding: 0rem 0.5rem;
  }
  .${classes.flagButton} {
    padding: 0rem 0.5rem;
  }
  .MuiFormHelperText-root {
    font-size: inherit;
  }
`;

export const ModalPhoneNumberInput = memo(function ModalPhoneNumberInput(
  props: PhoneNumberInputProps,
) {
  const {
    sx,
    name,
    value,
    onChange,
    onValid,
    setPhoneValidationError,
    ...rest
  } = props;
  const [phoneNumber, setPhoneNumber] = useState(value);
  const { t } = useTranslation();
  const companyInfo = useRecoilValue(accountCompanyInfoAtom);
  console.log('rerender phone number');

  return (
    <ModalStyledPhoneNumberInput
      sx={{ width: '100%', ...sx }}
      name={name}
      value={phoneNumber}
      size="small"
      defaultCountry={(companyInfo?.country_code as CountryCode) ?? 'GB'}
      onChange={v => {
        setPhoneValidationError('');
        const phone_number_string = parseIncompletePhoneNumber(v);
        setPhoneNumber(v.toString());
        console.log(phone_number_string);
        try {
          const phone_number = parsePhoneNumberWithError(phone_number_string);
          if (!isValidNumber(phone_number_string, phone_number.country)) {
            setPhoneValidationError(t('Please provide a valid phone number!'));
            return;
          }
          onValid(phone_number_string);
          //if (changeUser == null) { return; }
          //props.setChangeUser({...changeUser, phone_number: phone_number_string, change_email_phone: true});
        } catch (_) {
          //console.log(e)
          setPhoneValidationError(t('Please provide a valid phone number!'));
        }
      }}
      {...rest}
    />
  );
});
